import { fetcher } from '@shared/fetcher';
import { IProduct, ProductSchema } from '@shared/types.ts';

export async function fetchPopularProducts(url: string) {
  const res = await fetcher.get<{ data: IProduct[] }>(url).catch(() => null);
  if (!res?.data) return undefined;
  return res?.data.data.filter((i) => ProductSchema.isValidSync(i));
}
